
import XLSX from "xlsx";


export class ExcelUtils {

  /**
   * Get default options for Excel export (sample data for tax report)
   * @param {Object} translate - Translation object from i18n reducer (optional)
   * @returns {Object} Default options with translated labels
   */
  static getDefaultOptions(translate = {}) {
    const options = {
      sheetName: "Sheet 1",
      header: [
        {
          seqNo: 1,
          row: 1,
          label: translate.ISA_Sequence || "ลำดับ",
          width: "5",
          style: {
            align: "center"
          }
        },
        {
          seqNo: 2,
          label: translate.ISA_ReportOutputTaxTaxInvoice || "ใบกำกับภาษี",
          width: "25",
          style: {
            align: "center"
          }
        },
        {
          seqNo: 3,
          label: translate.ISA_DateMonthYear || "วัน เดือน ปี",
          width: "10",
          style: {
            align: "center"
          }
        },
        {
          seqNo: 4,
          label: translate.ISA_BuyerName || "ชื่อผู้ซื้อสินค้า",
          width: "40",
          style: {
            align: "center"
          }
        },
        {
          seqNo: 5,
          label: translate.ISA_ReportOutputTaxTaxTitle || "เลขประจำตัวผู้เสียภาษีอากร",
          width: "40",
          style: {
            align: "center"
          }
        },
        {
          seqNo: 6,
          label: translate.ISA_ReportOutputTaxOfficeName || "สถานประกอบการ",
          width: "40",
          style: {
            align: "center"
          }
        },
        {
          seqNo: 7,
          label: translate.ISA_ReportOutputTaxAmountOfGoods || "มูลค่าสินค้าหรือบริการ",
          width: "20",
          style: {
            align: "center"
          }
        },
        {
          seqNo: 8,
          label: translate.ISA_ReportOutputTaxVat || "จำนวนเงินภาษีมูลค่าเพิ่ม",
          width: "20",
          style: {
            align: "center"
          }
        },
        {
          seqNo: 9,
          label: translate.ISA_Remark || "หมายเหตุ",
          width: "60",
          style: {
            align: "center"
          }
        },
      ],
      // Sample data for preview/testing purposes
      items: [
        [
          {
            seqNo: "1",
            label: "1",
            style: {
              align: "center"
            }
          },
          {
            seqNo: "2",
            label: "CRVCS4241108001",
            style: {
              align: "center"
            }
          },
          {
            seqNo: "3",
            label: "08/11/2567",
            style: {
              align: "center"
            }
          },
          {
            seqNo: "4",
            label: "Sample Company Ltd.", // Sample company name
            style: {
              align: "left"
            }
          },
          {
            seqNo: "5",
            label: "",
            style: {
              align: "center"
            }
          },
          {
            seqNo: "6",
            label: "",
            style: {
              align: "center"
            }
          },
          {
            seqNo: "7",
            label: "( 154.20 )",
            style: {
              align: "center"
            }
          },
          {
            seqNo: "8",
            label: "( 10.79 ) ",
            style: {
              align: "center"
            }
          },
          {
            seqNo: "9",
            label: "IRVCS4241108001\n(08/11/2567)",
            style: {
              align: "center"
            }
          },
        ]
      ],
      headerOptions: {
        startRow: 1,
        style: {
          fontWeight: "",
          fontSize: "",
          align: "center",
          color: "",
        }
      },
      itemOptions: {
        style: {
          fontWeight: "",
          fontSize: "",
          align: "",
          color: "",
        }
      },
      rowOptions: {
      },
      cell: {
      }
    }
    return options;
  }

  static async download(workbook, options = { fileName: "report.xlsx" }) {
    const { fileName } = options;

    const excelBuffer = XLSX.write(workbook, { 
      bookType: "xlsx", 
      type: "array",
      cellStyles: true  // เพิ่ม option นี้เพื่อให้ hyperlink แสดงสีน้ำเงิน
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}